import styled, { CSSProp, css } from "styled-components";

export const ErrorWrapper = styled.div<{ remSize?: number; pTagCss?: CSSProp }>`
  width: 100% !important;
  p {
    color: #d32f2f !important;
    font-weight: 500;
    text-align: center;
    font-size: ${(props) => `${props.remSize}rem` || "0.75rem"};
    ${(props) => props.pTagCss}
  }
`;

export const customScroll = css`
/* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
  scrollbar-width: auto;
  scrollbar-color: #9f9f9f #2c2c2c;
}

*::-webkit-scrollbar-track {
  background: #2c2c2c;
}

*::-webkit-scrollbar-thumb {
  background-color: #9f9f9f;
  border-radius: 19px;
}
`